const state = {
  isScopeLanguages: false,
}

const getters = {
  isScopeLanguages(state) {
    return state.isScopeLanguages;
  },
}

const actions = {
  changeScopeLanguagesStatus({commit}, isScopeLanguages) {
    commit("setScopeLanguagesStatus", isScopeLanguages);
  },
}

const mutations = {
  setScopeLanguagesStatus(state, isScopeLanguages) {
    state.isScopeLanguages = isScopeLanguages;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
